"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvertedColorScheme = void 0;
const getInvertedColorScheme = (colorScheme) => {
    const { bg, fg, primary, secondary, palette, name } = colorScheme;
    return {
        name,
        bg: fg,
        fg: bg,
        primary: {
            bg: primary.fg,
            base: primary.base,
            fg: primary.bg,
        },
        secondary: {
            bg: secondary.fg,
            base: secondary.base,
            fg: secondary.bg,
        },
        palette,
    };
};
exports.getInvertedColorScheme = getInvertedColorScheme;
